import HeaderLinkBoxModule from '../HeaderLinkBoxModule/HeaderLinkBoxModule'
import LinkBoxSeLogerModule from '../LinkBoxSeLogerModule/LinkBoxSeLogerModule'
import ZoneInfoModule from '../ZoneInfoModule/ZoneInfoModule'
import SubZonesModule from '../SubZonesModule/SubZonesModule'
import HighlightModule from '../HighlightModule/HighlightModule'
import TopDepartmentsModule from '../TopDepartmentsModule/TopDepartmentsModule'
import CountryModule from '../CountryModule/CountryModule'
import CityModule from '../CityModule/CityModule'
import AdjacentCitiesModule from '../AdjacentCitiesModule/AdjacentCitiesModule'

const ModulesMappingConfiguration = {
  HeaderLinkBox: HeaderLinkBoxModule,
  LinkBoxSl: LinkBoxSeLogerModule,
  ZoneInformation: ZoneInfoModule,
  SubZones: SubZonesModule,
  Highlight: HighlightModule,
  TopDepartments: TopDepartmentsModule,
  Countries: CountryModule,
  Cities: CityModule,
  AdjacentCitiesService: AdjacentCitiesModule,
}

export default ModulesMappingConfiguration
